import { SVGProps } from "react";

const Question = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={27}
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={13}
      cy={13.4181}
      r={10.8333}
      stroke="currentColor"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 15.5847V15.2814C13 14.2992 13.5482 13.7792 14.0964 13.3603C14.6316 12.9559 15.1666 12.4359 15.1666 11.4825C15.1666 10.1537 14.2008 9.08472 13 9.08472C11.7992 9.08472 10.8333 10.1537 10.8333 11.4825"
      stroke="currentColor"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9903 17.7513H13.0098"
      stroke="currentColor"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Question;
